import { render } from "./SidebarHeader.vue?vue&type=template&id=159c5a48"
import script from "./SidebarHeader.vue?vue&type=script&lang=js"
export * from "./SidebarHeader.vue?vue&type=script&lang=js"

import "./SidebarHeader.vue?vue&type=style&index=0&id=159c5a48&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__